<lfx-mini-card
  [title]="project.name"
  [details]="project.description"
  [logo]="project.logoUrl"
  [icon]="defaultIcon"
  buttonType="success"
  [buttonText]="buttonName"
  (action)="onButtonClick()"
></lfx-mini-card>
